<template>
  <base-content>
    <template v-slot:top>
      <hero-header heading="Account ready" />
    </template>

    <p class="lead text-center">
      Your account has now been setup and is ready to go.
    </p>

    <template v-slot:bottom>
      <div class="bg-light py-4">
        <div class="container">
          <div class="row">
            <div class="col-sm-12 text-right">
              <base-button class="mr-2" :to="{ name: 'co-funding' }">
                View investment opportunities
              </base-button>
              <base-button secondary :to="{ name: 'account.topup', params: { id: account._id } }">
                Topup your account
              </base-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-content>
</template>

<script>
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    HeroHeader
  },

  data: () => ({
    account: {}
  }),

  created () {
    this.account = this.$auth.user.accounts.find(account => account._id === this.$route.params.id)
  }
}
</script>
